export default {
  computed: {
    chatReady() { return this.$store.state.wsReady; },
    historyConversation() {
      const selected = this.curItem || this.service || {};
      return this.$store.state.Chat.chatList.find(user => user.uid == selected.uid) || selected;
    },
    historyLabel() {
      const user = this.historyConversation;
      if (user.historyLoading || user.syncingHistory) return this.$t('tips.loading');
      if (user.historyError) return this.$t('chat.historyFailed');
      return this.$t(user.hasMoreHistory === false ? 'chat.noHistory' : 'chat.queryhistory');
    },
  },
  watch: {
    chatReady(ready) {
      if (ready) { this.historyConversation.historyError = false; this.ensureRecentHistory(); }
    },
    'historyConversation.uid': { immediate: true, handler() { this.ensureRecentHistory(); } },
    'historyConversation.historyLoading'() { this.ensureRecentHistory(); },
    'historyConversation.syncingHistory'() { this.ensureRecentHistory(); },
  },
  methods: {
    ensureRecentHistory() {
      const user = this.historyConversation;
      if (this.chatReady && user.uid && user.historyLoaded !== true && !user.historyLoading &&
          !user.syncingHistory && !user.historyError) {
        this.$store.dispatch('loadChatHistory', { address: user.uid, initial: true });
      }
    },
    async queryHistory() {
      const user = this.historyConversation;
      if (user.historyLoading || user.syncingHistory) return false;
      if (user.recoveryAfterId != null && user.recoveryUntilId > user.recoveryAfterId) {
        return this.$store.dispatch('syncChatHistory', {
          address: user.uid, after_id: user.recoveryAfterId, until_id: user.recoveryUntilId,
        });
      }
      if (user.hasMoreHistory === false) return false;
      if (this.captureHistoryPosition) this.captureHistoryPosition();
      const anchor = this.historyAnchor;
      const result = await this.$store.dispatch('loadChatHistory', { address: user.uid, initial: user.historyLoaded !== true });
      if (!result && this.captureHistoryPosition && this.historyAnchor === anchor) this.historyAnchor = null;
      return result;
    },
  },
};
